module.exports = __webpack_public_path__ + "img/dynamic-15.060bf81a.png";